class StickyAddToCart {
  constructor(bar) {
    this.bar = bar;
    this.formId = this.bar.querySelector('button[form]').getAttribute('form');
    this.form = document.getElementById(this.formId);
    this.button = this.bar.querySelector('.sticky-atc-bar__button');
    this.mainButton = this.form?.querySelector('button[type="submit"]:not([form])');
    this.hasScrolled = false;
    
    if (!this.form || !this.mainButton) return;
    
    this.preventSubmit = this.preventSubmit.bind(this);
    this.init();
  }

  init() {
    // Ensure bar starts hidden
    this.bar.classList.remove('show');
    
    this.validateForm();
    
    window.addEventListener('scroll', () => {
      this.hasScrolled = true;
      this.handleScroll();
    }, { once: true });
    
    window.addEventListener('scroll', () => this.handleScroll());
    this.form.addEventListener('input', () => this.validateForm());
    this.form.addEventListener('change', () => this.validateForm());
    this.button.addEventListener('click', (e) => this.handleClick(e));
    
    this.observeFormChanges();
  }

  observeFormChanges() {
    const observer = new MutationObserver(() => {
      this.validateForm();
      // Only update scroll state if user has scrolled
      if (this.hasScrolled) {
        this.handleScroll();
      }
    });
    
    observer.observe(this.form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['required', 'value']
    });
  }

  handleScroll() {
    if (!this.mainButton) return;
    
    const mainButtonRect = this.mainButton.getBoundingClientRect();

    // If button has no dimensions, it's not rendered - keep bar hidden
    if (mainButtonRect.height === 0 || mainButtonRect.width === 0) {
      this.bar.classList.remove('show');
      return;
    }
    
    const isMainButtonVisible = mainButtonRect.bottom > 0 && mainButtonRect.top < window.innerHeight;
    const tidioChat = document.getElementById('tidio-chat');
    
    if (tidioChat) {
      tidioChat.style.transition = 'bottom 0.3s ease';
    }
    
    if (isMainButtonVisible) {
      this.bar.classList.remove('show');
      if (tidioChat) {
        tidioChat.style.bottom = '0';
      }
    } else {
      this.bar.classList.add('show');
      if (tidioChat) {
        tidioChat.style.bottom = '70px';
      }
    }
  }

  validateForm() {
    const requiredInputs = this.form.querySelectorAll('input[required], select[required], textarea[required]');
    const optionRequiredInputs = this.form.querySelectorAll('.option-required input, .option-required select, .option-required textarea');
    
    let isValid = true;
    
    requiredInputs.forEach(input => {
      if (input.type === 'radio') {
        const radioGroup = this.form.querySelector(`input[name="${input.name}"]:checked`);
        if (!radioGroup) {
          isValid = false;
        }
      } else if (input.type === 'checkbox') {
        if (!input.checked) {
          isValid = false;
        }
      } else {
        if (!input.value || input.value.trim() === '') {
          isValid = false;
        }
      }
    });
    
    optionRequiredInputs.forEach(input => {
      if (!input.value || input.value.trim() === '') {
        isValid = false;
      }
    });
    
    this.button.classList.toggle('disabled', !isValid);
  }

  handleClick(e) {
    if (this.button.classList.contains('disabled')) {
      e.preventDefault();
      e.stopPropagation();
      
      const productInfoForm = document.querySelector('product-info form[action="/cart/add"]');
      const disabledSubmitButton = document.querySelector('.product-form__submit.button--disabled');
      
      if (productInfoForm) {
        let element = productInfoForm;
        let offsetTop = 0;
        
        while (element) {
          offsetTop += element.offsetTop;
          element = element.offsetParent;
        }
        
        window.scrollTo({
          top: offsetTop - 100,
          behavior: 'smooth'
        });
        
        setTimeout(() => {
          if (disabledSubmitButton) {
            disabledSubmitButton.click();
          }
        }, 300);
      }
      
      return false;
    }
  }

  findFirstInvalidInput() {
    const requiredInputs = this.form.querySelectorAll('input[required], select[required], textarea[required]');
    const optionRequiredInputs = this.form.querySelectorAll('.option-required input, .option-required select, .option-required textarea');

    
    for (let input of requiredInputs) {
      if (input.type === 'radio') {
        const radioGroup = this.form.querySelector(`input[name="${input.name}"]:checked`);
        if (!radioGroup) return input;
      } else if (input.type === 'checkbox') {
        if (!input.checked) return input;
      } else if (input.tagName === 'SELECT') {
        if (!input.value || input.value === '') return input;
      } else {
        if (!input.value || input.value.trim() === '') return input;
      }
    }
    
    for (let input of optionRequiredInputs) {
      if (input.tagName === 'SELECT') {
        if (!input.value || input.value == '') return input;
      } else {
        if (!input.value || input.value.trim() == '') return input;
      }
    }
    
    return null;
  }

  preventSubmit(e) {
    e.preventDefault();
    e.stopPropagation();
    return false;
  }
}

// Uncomment when implementing
// document.addEventListener('DOMContentLoaded', () => {
//   const stickyBar = document.querySelector('[data-sticky-atc-bar]');
//   if (stickyBar) {
//     new StickyAddToCart(stickyBar);
//   }
// });
